<template>
  <div class="claims-page">
    <el-card shadow="never">
      <div class="search-toolbar">
        <el-form :inline="true" size="small" class="search-form">
          <div class="filter-fields">
          <el-form-item label="时间"
            ><el-date-picker
              v-model="search.date"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
          /></el-form-item>
          <el-form-item label="保单号"><el-input v-model.trim="search.policy" placeholder="请输入保单号" clearable @keyup.enter.native="handleSearch" /></el-form-item>
          <el-form-item label="被保险人"><el-input v-model.trim="search.beneficiary" placeholder="请输入被保险人" clearable @keyup.enter.native="handleSearch" /></el-form-item>
          <el-form-item label="渠道"
            ><el-select
              v-model="search.channel"
              filterable
              clearable
              placeholder="选择渠道"
              ><el-option
                v-for="item in channels"
                :key="item.id"
                :label="item.realname || item.name"
                :value="Number(item.id)"/></el-select
          ></el-form-item>
          <el-form-item label="保险公司"
            ><el-select
              v-model="search.company"
              filterable
              clearable
              placeholder="选择保险公司"
              ><el-option
                v-for="item in companies"
                :key="item.id"
                :label="item.name"
                :value="Number(item.id)"/></el-select
          ></el-form-item>
          <el-form-item label="产品"
            ><el-select
              v-model="search.product"
              filterable
              clearable
              placeholder="选择产品"
              ><el-option
                v-for="item in products"
                :key="item.id"
                :label="item.name"
                :value="Number(item.id)"/></el-select
          ></el-form-item>
          <el-form-item label="案件号"><el-input v-model.trim="search.claims" placeholder="请输入报案号码" clearable @keyup.enter.native="handleSearch" /></el-form-item>
          <el-form-item label="案件进度"
            ><el-select v-model="search.progress" clearable placeholder="案件进度"
              ><el-option
                v-for="item in progressOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"/></el-select
          ></el-form-item>
          <el-form-item label="案件状态"
            ><el-select v-model="search.status" clearable placeholder="案件状态"
              ><el-option
                v-for="(label, value) in statusMap"
                :key="value"
                :label="label"
                :value="Number(value)"/></el-select
          ></el-form-item>
          <template v-if="riskType === 2"
            ><el-form-item
              ><el-input
                v-model.trim="search.province"
                placeholder="客户省份"
                clearable/></el-form-item
            ><el-form-item
              ><el-input
                v-model.trim="search.city"
                placeholder="客户城市"
                clearable/></el-form-item
          ></template>
          </div>
          <div class="toolbar-row">
            <el-form-item class="search-actions"
              ><el-button type="primary" @click="handleSearch">搜索</el-button
              ><el-button @click="resetSearch">重置</el-button></el-form-item
            >
            <div class="toolbar-actions">
              <el-button
                type="primary"
                size="small"
                icon="el-icon-plus"
                @click="registerClaim"
                >登记案件</el-button
              >
              <el-button
                type="warning"
                size="small"
                icon="el-icon-upload2"
                @click="$refs.importFile.click()"
                >批量导入案件</el-button
              >
              <el-button type="text" size="small" @click="downloadImportTemplate"
                >下载导入模板</el-button
              >
              <el-button
                type="success"
                size="small"
                icon="el-icon-download"
                @click="exportExcel"
                >导出Excel</el-button
              >
              <input
                ref="importFile"
                type="file"
                accept=".xls,.xlsx"
                hidden
                @change="importExcel"
              />
            </div>
          </div>
        </el-form>
      </div>

      <el-table
        v-loading="loading"
        :data="rows"
        border
        stripe
        height="620"
        class="claim-table"
        :row-class-name="rowClassName"
      >
        <el-table-column label="操作" width="115" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="isClosed(scope.row)"
              type="text"
              @click="toggleClosed(scope.row)"
              >复案</el-button
            >
            <el-dropdown
              v-else
              trigger="click"
              @command="command => handleAction(command, scope.row)"
              ><el-button type="primary" size="mini"
                >案件处理<i
                  class="el-icon-arrow-down el-icon--right"/></el-button
              ><el-dropdown-menu slot="dropdown"
                ><el-dropdown-item
                  v-for="action in actions"
                  :key="action.value"
                  :command="action.value"
                  :divided="action.divided"
                  >{{ action.label }}</el-dropdown-item
                ></el-dropdown-menu
              ></el-dropdown
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="case_progress"
          label="案件进度"
          width="125"
          :formatter="progressFormatter"
        />
        <el-table-column prop="case_status" label="案件状态" width="95"
          ><template slot-scope="scope"
            ><el-tooltip
              v-if="Number(scope.row.case_status) === 2"
              :content="scope.row.case_reason || '无异常原因'"
              ><span class="danger-text">异常</span></el-tooltip
            ><span v-else>{{
              statusMap[scope.row.case_status] || "-"
            }}</span></template
          ></el-table-column
        >
        <el-table-column prop="identity_name" label="案件定性" width="110" />
        <el-table-column
          prop="beneficiary"
          label="被保险人"
          width="220"
          show-overflow-tooltip
        />
        <el-table-column prop="claims_number" label="报案号码" width="140" />
        <el-table-column prop="policy_no" label="保单号码" width="190" />
        <template v-if="riskType === 1"
          ><el-table-column
            prop="cargo_type_name"
            label="货物类型"
            width="120"/><el-table-column
            prop="cargo_names"
            label="货物品名"
            width="140"
        /></template>
        <template v-else
          ><el-table-column
            prop="wounded_name"
            label="伤者姓名"
            width="110"/><el-table-column
            prop="wounded_jobs"
            label="伤者工种"
            width="110"
            ><template slot-scope="scope">{{
              jobs[scope.row.wounded_jobs] || "-"
            }}</template></el-table-column
          ><el-table-column prop="wounded_id_card" label="身份证号" width="180"
        /></template>
        <el-table-column
          prop="risk_at"
          label="出险日期"
          width="115"
          :formatter="dateFormatter"
        />
        <el-table-column
          prop="risk_province"
          label="出险省份"
          width="100"
        /><el-table-column prop="risk_city" label="出险城市" width="100" />
        <el-table-column
          v-if="riskType === 1"
          prop="risk_rold"
          label="出险路段"
          width="110"
        /><el-table-column
          v-if="riskType === 1"
          prop="detailed_address"
          label="详细地址"
          width="180"
          show-overflow-tooltip
        />
        <el-table-column prop="case_process" label="案件经过" width="100"
          ><template slot-scope="scope"
            ><el-popover
              v-if="scope.row.case_process"
              placement="top"
              width="360"
              trigger="click"
              :content="scope.row.case_process"
              ><el-button slot="reference" type="text"
                >查看</el-button
              ></el-popover
            ><span v-else>-</span></template
          ></el-table-column
        >
        <el-table-column
          prop="accident_consequences"
          label="事故后果"
          width="120"
        /><el-table-column
          prop="reason_name_one"
          label="原因一级"
          width="110"
        /><el-table-column
          prop="reason_name_two"
          label="原因二级"
          width="110"
        /><el-table-column
          prop="reason_name_three"
          label="原因三级"
          width="110"
        />
        <el-table-column
          v-if="riskType === 1"
          prop="feasibility_of_recovery_three"
          label="第三者追偿可行性"
          width="145"
          ><template slot-scope="scope">{{
            scope.row.feasibility_of_recovery_three ? "是" : "否"
          }}</template></el-table-column
        ><el-table-column
          v-if="riskType === 1"
          prop="feasibility_of_recovery_downstream"
          label="下游追偿可行性"
          width="145"
          ><template slot-scope="scope">{{
            scope.row.feasibility_of_recovery_downstream ? "是" : "否"
          }}</template></el-table-column
        >
        <el-table-column
          v-if="riskType === 2"
          prop="damage_situation"
          label="损伤情形"
          width="160"
          show-overflow-tooltip
        />
        <el-table-column
          prop="estimated_amount"
          label="估损金额(元)"
          width="115"
          :formatter="moneyFormatter"
        />
        <template v-if="riskType === 1"
          ><el-table-column
            prop="claim_amount"
            label="索赔金额(元)"
            width="115"
            :formatter="moneyFormatter"/><el-table-column
            prop="register_amount"
            label="立案金额(元)"
            width="115"
            :formatter="moneyFormatter"/><el-table-column
            prop="loss_amount"
            label="定损金额(元)"
            width="115"
            :formatter="moneyFormatter"
        /></template>
        <template v-else
          ><el-table-column
            prop="medical_losses"
            label="医疗损失(元)"
            width="115"
            :formatter="moneyFormatter"/><el-table-column
            prop="work_losses"
            label="误工损失(元)"
            width="115"
            :formatter="moneyFormatter"/><el-table-column
            prop="disability_level"
            label="伤残等级"
            width="110"
            ><template slot-scope="scope">{{
              disabilityLevels[scope.row.disability_level] || "无"
            }}</template></el-table-column
          ><el-table-column
            prop="disability_losses"
            label="伤残损失(元)"
            width="115"
            :formatter="moneyFormatter"/><el-table-column
            prop="died_losses"
            label="死亡损失(元)"
            width="115"
            :formatter="moneyFormatter"/><el-table-column
            prop="total_losses"
            label="损失合计(元)"
            width="115"
            :formatter="moneyFormatter"
        /></template>
        <el-table-column prop="paid_amount" label="实际赔偿金额(元)" width="140"
          ><template slot-scope="scope"
            ><el-link
              v-if="scope.row.pay_url"
              type="primary"
              @click="openPayFiles(scope.row)"
              >{{ money(scope.row.paid_amount) }}</el-link
            ><span v-else>{{ money(scope.row.paid_amount) }}</span></template
          ></el-table-column
        >
        <el-table-column
          prop="paid_date"
          label="付款日期"
          width="115"
          :formatter="dateFormatter"
        /><el-table-column
          prop="claimed_date"
          label="结案时间"
          width="115"
          :formatter="dateFormatter"
        />
        <el-table-column
          v-if="riskType === 2"
          prop="is_three"
          label="第三者责任"
          width="115"
          ><template slot-scope="scope">{{
            Number(scope.row.is_three) === 1
              ? "涉及三者"
              : Number(scope.row.is_three) === 2
              ? "非涉及三者"
              : "-"
          }}</template></el-table-column
        ><el-table-column
          v-if="riskType === 2"
          prop="case_circulation_time"
          label="预估处理时间"
          width="125"
          ><template slot-scope="scope">{{
            circulationMap[scope.row.case_circulation_time] || "-"
          }}</template></el-table-column
        >
        <el-table-column
          prop="loss_amount_time"
          label="结案周期"
          width="120"
        /><el-table-column
          prop="policyholder"
          label="投保人"
          width="180"
          show-overflow-tooltip
        /><el-table-column
          prop="customer_province"
          label="客户省份"
          width="100"
        /><el-table-column
          prop="customer_city"
          label="客户城市"
          width="100"
        /><el-table-column
          prop="product_name"
          label="产品名称"
          width="140"
        /><el-table-column
          prop="insurer_company_name"
          label="保险公司"
          width="180"
          show-overflow-tooltip
        /><el-table-column
          prop="top_channel_name"
          label="顶级渠道"
          width="140"
        /><el-table-column
          prop="pay_price"
          label="保费(元)"
          width="100"
          :formatter="moneyFormatter"
        /><el-table-column
          prop="effected_at"
          label="生效时间"
          width="115"
          :formatter="dateFormatter"
        /><el-table-column
          prop="expired_at"
          label="失效时间"
          width="115"
          :formatter="dateFormatter"
        /><el-table-column
          prop="earned_premium"
          label="满期保费(元)"
          width="115"
          :formatter="moneyFormatter"
        /><el-table-column prop="payout_rate" label="满期赔付率" width="110" />
      </el-table>
      <el-pagination
        class="pagination"
        :current-page="page"
        :page-size="pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 15, 20]"
        @current-change="changePage"
        @size-change="changeSize"
      />
    </el-card>

    <claim-editor
      :visible.sync="editorVisible"
      :mode="editorMode"
      :risk-type="riskType"
      :claim-id="currentRow && currentRow.id"
      :policy-no="registerPolicyNo"
      @saved="fetchList"
    />
    <record-history-dialog
      :visible.sync="historyVisible"
      :order-id="currentRow && currentRow.id"
      :mode="historyMode"
      @changed="fetchList"
    />
    <media-dialog
      :visible.sync="mediaVisible"
      :order-id="currentRow && currentRow.id"
      :risk-type="riskType"
    />
    <compensation-dialog
      :visible.sync="compensationVisible"
      :order-id="currentRow && currentRow.id"
      :risk-type="riskType"
      @changed="fetchList"
    />
    <employee-loss-dialog
      :visible.sync="lossVisible"
      :order-id="currentRow && currentRow.id"
      @changed="fetchList"
    />
    <notes-dialog
      :visible.sync="notesVisible"
      :order-id="currentRow && currentRow.id"
    />
    <claim-action-dialog
      :visible.sync="actionVisible"
      :action="currentAction"
      :order-id="currentRow && currentRow.id"
      :risk-type="riskType"
      @changed="fetchList"
    />
    <product-files-dialog
      :visible.sync="templatesVisible"
      :product-id="currentRow && currentRow.product_id"
    />
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import ExportJsonExcel from "js-export-excel";
import {
  getClaimList,
  importClaims,
  closeClaim,
  deleteClaim,
  getInsuranceCompanies,
  getProducts,
  getTopChannels
} from "@/api/claims-management";
import {
  RISK_KEYS,
  CASE_PROGRESS,
  CASE_STATUS,
  JOBS,
  DISABILITY_LEVELS,
  CIRCULATION_TIMES,
  formatDate,
  fromCents,
  toCents,
  toTimestamp
} from "./constants";
import ClaimEditor from "./components/ClaimEditor.vue";
import RecordHistoryDialog from "./components/RecordHistoryDialog.vue";
import MediaDialog from "./components/MediaDialog.vue";
import CompensationDialog from "./components/CompensationDialog.vue";
import EmployeeLossDialog from "./components/EmployeeLossDialog.vue";
import NotesDialog from "./components/NotesDialog.vue";
import ClaimActionDialog from "./components/ClaimActionDialog.vue";
import ProductFilesDialog from "./components/ProductFilesDialog.vue";

export default {
  name: "ClaimList",
  components: {
    ClaimEditor,
    RecordHistoryDialog,
    MediaDialog,
    CompensationDialog,
    EmployeeLossDialog,
    NotesDialog,
    ClaimActionDialog,
    ProductFilesDialog
  },
  props: { riskType: { type: Number, required: true } },
  data() {
    return {
      loading: false,
      rows: [],
      total: 0,
      page: 1,
      pageSize: 15,
      search: {
        date: [],
        policy: "",
        beneficiary: "",
        channel: "",
        company: "",
        product: "",
        claims: "",
        progress: "",
        status: "",
        province: "",
        city: ""
      },
      products: [],
      companies: [],
      channels: [],
      progressMap: CASE_PROGRESS,
      statusMap: CASE_STATUS,
      jobs: JOBS,
      disabilityLevels: DISABILITY_LEVELS,
      circulationMap: CIRCULATION_TIMES,
      currentRow: null,
      editorVisible: false,
      editorMode: "create",
      registerPolicyNo: "",
      historyVisible: false,
      historyMode: "status",
      mediaVisible: false,
      compensationVisible: false,
      lossVisible: false,
      notesVisible: false,
      actionVisible: false,
      currentAction: "",
      templatesVisible: false
    };
  },
  computed: {
    progressOptions() {
      return Object.keys(this.progressMap)
        .filter(value => Number(value))
        .map(value => ({
          value: Number(value),
          label: this.progressMap[value]
        }));
    },
    actions() {
      const common = [
        { label: "查看案件", value: "view" },
        { label: "编辑案件", value: "edit" },
        { label: "影像资料", value: "media" },
        { label: "异常登记", value: "status" },
        { label: "进度变更", value: "progress" },
        { label: "审核记录", value: "audit" },
        { label: "案件备注", value: "notes" },
        { label: "理赔资料模板", value: "templates" }
      ];
      const special =
        this.riskType === 1
          ? [
              { label: "追偿可行性", value: "recovery" },
              { label: "索赔金额", value: "claim_amount" },
              { label: "立案金额", value: "register_amount" },
              { label: "定损金额", value: "loss_amount" }
            ]
          : [
              { label: "损失明细", value: "losses" },
              { label: "损伤情形", value: "damage" },
              { label: "第三者责任", value: "third" },
              { label: "预估处理时间", value: "circulation" }
            ];
      return common.concat(special, [
        { label: "赔偿金额", value: "compensation" },
        { label: "结案", value: "finish", divided: true },
        { label: "销案", value: "close" },
        { label: "删除", value: "delete" }
      ]);
    }
  },
  created() {
    this.fetchList();
    this.loadSearchOptions();
  },
  methods: {
    async loadSearchOptions() {
      const [products, companies, channels] = await Promise.all([
        getProducts({ page: 1, rows: 1000 }),
        getInsuranceCompanies({ page: 1, rows: 1000 }),
        getTopChannels({ page: 1, rows: 1000 })
      ]);
      this.products = products.rows || [];
      this.companies = companies.rows || [];
      this.channels = channels.rows || [];
    },
    buildParams(all = false) {
      const params = all ? {} : { page: this.page, rows: this.pageSize };
      if (
        this.search.date &&
        this.search.date.length === 2
      ) {
        params.begin_date = toTimestamp(`${this.search.date[0]} 00:00:00`);
        params.end_date = toTimestamp(`${this.search.date[1]} 23:59:59`);
      }
      if (this.search.policy) params.policy_no = this.search.policy;
      if (this.search.beneficiary) params.beneficiary = this.search.beneficiary;
      if (this.search.channel) params.top_channel_id = this.search.channel;
      if (this.search.company) params.insurer_company_id = this.search.company;
      if (this.search.product) params.product_id = this.search.product;
      if (this.search.claims) params.claims_number = this.search.claims;
      if (this.search.progress) params.case_progress = this.search.progress;
      if (this.search.status) params.case_status = this.search.status;
      if (this.riskType === 2) {
        if (this.search.province)
          params.customer_province = this.search.province;
        if (this.search.city) params.customer_city = this.search.city;
      }
      return params;
    },
    async fetchList() {
      this.loading = true;
      try {
        const res = await getClaimList(
          RISK_KEYS[this.riskType],
          this.buildParams()
        );
        this.rows = res.rows || [];
        this.total = Number(res.total || this.rows.length);
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.page = 1;
      this.fetchList();
    },
    resetSearch() {
      this.search = {
        date: [], policy: "", beneficiary: "", channel: "", company: "",
        product: "", claims: "", progress: "", status: "", province: "", city: ""
      };
      this.page = 1;
      this.fetchList();
    },
    registerClaim() {
      this.$prompt("请输入保单号码", "登记案件", {
        inputPattern: /\S+/,
        inputErrorMessage: "请输入保单号码",
        confirmButtonText: "下一步",
        cancelButtonText: "取消"
      })
        .then(({ value }) => {
          this.currentRow = null;
          this.registerPolicyNo = value.trim();
          this.editorMode = "create";
          this.editorVisible = true;
        })
        .catch(() => {});
    },
    downloadImportTemplate() {
      window.open(
        this.riskType === 1
          ? "https://www.jubao56.com/res/2024/05/11/14/3313574/理赔系统一键上传模板(货运险).xls"
          : "https://www.jubao56.com/res/2024/05/11/14/3231060/理赔系统一键上传模板(员工险).xls",
        "_blank"
      );
    },
    handleAction(command, row) {
      this.currentRow = row;
      if (["view", "edit"].includes(command)) {
        this.editorMode = command;
        this.editorVisible = true;
        return;
      }
      if (["status", "progress", "audit"].includes(command)) {
        this.historyMode = command;
        this.historyVisible = true;
        return;
      }
      if (command === "media") this.mediaVisible = true;
      else if (command === "compensation") this.compensationVisible = true;
      else if (command === "losses") this.lossVisible = true;
      else if (command === "notes") this.notesVisible = true;
      else if (command === "templates") this.templatesVisible = true;
      else if (
        [
          "recovery",
          "claim_amount",
          "register_amount",
          "loss_amount",
          "damage",
          "third",
          "circulation",
          "finish"
        ].includes(command)
      ) {
        this.currentAction = command;
        this.actionVisible = true;
      } else if (command === "close") this.toggleClosed(row);
      else if (command === "delete") this.remove(row);
    },
    isClosed(row) {
      return Number(row.case_status) === 4 || row.closed === true;
    },
    toggleClosed(row) {
      const closed = this.isClosed(row);
      this.$confirm(`确认${closed ? "复案" : "销案"}吗？`, "提示", {
        type: "warning"
      })
        .then(async () => {
          await closeClaim(RISK_KEYS[this.riskType], {
            id: Number(row.id),
            closed: !closed
          });
          this.$message.success("修改成功");
          this.fetchList();
        })
        .catch(() => {});
    },
    remove(row) {
      this.$confirm("删除后无法恢复，确认删除该案件吗？", "删除案件", {
        type: "warning"
      })
        .then(async () => {
          await deleteClaim(RISK_KEYS[this.riskType], { id: Number(row.id) });
          this.$message.success("删除成功");
          this.fetchList();
        })
        .catch(() => {});
    },
    openPayFiles(row) {
      let files = [];
      try {
        files = JSON.parse(row.pay_url);
      } catch (error) {
        files = String(row.pay_url).split(",");
      }
      files.forEach(url => window.open(url, "_blank"));
    },
    async exportExcel() {
      this.loading = true;
      try {
        const res = await getClaimList(
          RISK_KEYS[this.riskType],
          this.buildParams(true)
        );
        const data = (res.rows || []).map(this.exportRow);
        if (!data.length) return this.$message.warning("导出数据为空");
        new ExportJsonExcel({
          fileName: `${this.riskType === 1 ? "货运险" : "雇主险"}理赔案件数据`,
          datas: [
            {
              sheetData: data,
              sheetName: "理赔案件",
              sheetHeader: Object.keys(data[0])
            }
          ]
        }).saveExcel();
      } finally {
        this.loading = false;
      }
    },
    exportRow(row) {
      const base = {
        案件进度: this.progressMap[row.case_progress] || "-",
        案件状态: this.statusMap[row.case_status] || "-",
        案件定性: row.identity_name,
        被保险人: row.beneficiary,
        报案号码: row.claims_number,
        保单号码: row.policy_no,
        出险日期: formatDate(row.risk_at),
        出险省份: row.risk_province,
        出险城市: row.risk_city,
        案件经过: row.case_process,
        事故后果: row.accident_consequences,
        原因一级: row.reason_name_one,
        原因二级: row.reason_name_two,
        原因三级: row.reason_name_three,
        "估损金额(元)": this.money(row.estimated_amount),
        "实际赔偿金额(元)": this.money(row.paid_amount),
        付款日期: formatDate(row.paid_date),
        结案时间: formatDate(row.claimed_date),
        投保人: row.policyholder,
        客户省份: row.customer_province,
        客户城市: row.customer_city,
        产品名称: row.product_name,
        保险公司: row.insurer_company_name,
        顶级渠道: row.top_channel_name,
        "保费(元)": this.money(row.pay_price),
        生效时间: formatDate(row.effected_at),
        失效时间: formatDate(row.expired_at),
        "满期保费(元)": this.money(row.earned_premium),
        满期赔付率: row.payout_rate
      };
      if (this.riskType === 1)
        return {
          ...base,
          货物类型: row.cargo_type_name,
          货物品名: row.cargo_names,
          出险路段: row.risk_rold,
          详细地址: row.detailed_address,
          第三者追偿可行性: row.feasibility_of_recovery_three ? "是" : "否",
          下游追偿可行性: row.feasibility_of_recovery_downstream ? "是" : "否",
          "索赔金额(元)": this.money(row.claim_amount),
          "立案金额(元)": this.money(row.register_amount),
          "定损金额(元)": this.money(row.loss_amount)
        };
      return {
        ...base,
        伤者姓名: row.wounded_name,
        伤者工种: this.jobs[row.wounded_jobs] || "",
        身份证号: row.wounded_id_card,
        损伤情形: row.damage_situation,
        "医疗损失(元)": this.money(row.medical_losses),
        "误工损失(元)": this.money(row.work_losses),
        伤残等级: this.disabilityLevels[row.disability_level] || "无",
        "伤残损失(元)": this.money(row.disability_losses),
        "死亡损失(元)": this.money(row.died_losses),
        "损失合计(元)": this.money(row.total_losses),
        第三者责任:
          Number(row.is_three) === 1
            ? "涉及三者"
            : Number(row.is_three) === 2
            ? "非涉及三者"
            : "",
        预估处理时间: this.circulationMap[row.case_circulation_time] || ""
      };
    },
    async importExcel(event) {
      const file = event.target.files[0];
      event.target.value = "";
      if (!file) return;
      this.loading = true;
      try {
        const workbook = XLSX.read(await file.arrayBuffer(), { type: "array" });
        const source = XLSX.utils.sheet_to_json(
          workbook.Sheets[workbook.SheetNames[0]],
          { defval: "" }
        );
        const orderList = source.map((row, index) =>
          this.mapImportRow(row, index)
        );
        await importClaims(RISK_KEYS[this.riskType], { order_list: orderList });
        this.$message.success(`成功导入 ${orderList.length} 条案件`);
        this.fetchList();
      } catch (error) {
        if (error && error.message) this.$message.error(error.message);
      } finally {
        this.loading = false;
      }
    },
    mapImportRow(row, index) {
      if (!row["报案号码"]) throw new Error(`第 ${index + 1} 条报案号码为空`);
      if (!row["保单号码"]) throw new Error(`第 ${index + 1} 条保单号码为空`);
      const riskDate = row["出险日期(格式:2023-01-01)"] || row["出险日期"];
      if (!riskDate) throw new Error(`第 ${index + 1} 条出险日期为空`);
      const data = {
        case_status:
          { 已决: 1, 异常: 2, 未决: 8, 销案: 4 }[row["案件状态"]] || 0,
        identity_name: row["案件定性"],
        claims_number: String(row["报案号码"]),
        policy_no: String(row["保单号码"]),
        beneficiary: row["被保险人"],
        risk_province: row["出险省份"],
        risk_city: row["出险城市"],
        case_process: row["案件经过"],
        accident_consequences: row["事故后果"],
        reason_name_one: row["原因一级"],
        reason_name_two: row["原因二级"],
        reason_name_three: row["原因三级"],
        risk_at: this.parseExcelDate(riskDate),
        estimated_amount: this.parseMoney(row["估损金额"]),
        paid_amount: this.parseMoney(row["实际赔偿金额"]),
        policyholder: row["投保人"],
        customer_province: row["客户省份"],
        customer_city: row["客户城市"],
        product_name: row["产品名称"],
        pay_price: this.parseMoney(row["保费"]),
        top_channel_name: row["顶级渠道"],
        insurer_company_name: row["保险公司"],
        effected_at: this.parseExcelDate(
          row["生效时间(格式:2023-01-01 01:01:01)"] || row["生效时间"]
        ),
        expired_at: this.parseExcelDate(
          row["失效时间(格式:2023-01-01 01:01:01)"] || row["失效时间"]
        )
      };
      if (this.riskType === 1)
        Object.assign(data, {
          cargo_type_name: row["货物类型"],
          cargo_name: row["货物品名"],
          risk_rold: row["出险路段"],
          detailed_address: row["详细地址"]
        });
      else
        Object.assign(data, {
          wounded_name: row["伤者姓名"],
          wounded_jobs: Object.keys(this.jobs).find(
            key => this.jobs[key] === row["伤者工种"]
          )
            ? Number(
                Object.keys(this.jobs).find(
                  key => this.jobs[key] === row["伤者工种"]
                )
              )
            : 0,
          wounded_id_card: String(row["身份证号"] || "")
        });
      return data;
    },
    parseMoney(value) {
      if (value === "" || value === null || value === undefined) return 0;
      return toCents(String(value).replace(/[^\d.-]/g, ""));
    },
    parseExcelDate(value) {
      if (!value) return 0;
      if (typeof value === "number") {
        const date = XLSX.SSF.parse_date_code(value);
        return toTimestamp(
          `${date.y}-${date.m}-${date.d} ${date.H || 0}:${date.M ||
            0}:${Math.floor(date.S || 0)}`
        );
      }
      return toTimestamp(String(value).replace(/\//g, "-"));
    },
    money(value) {
      const result = fromCents(value);
      return result === "" ? "-" : Number(result).toFixed(2);
    },
    moneyFormatter(row, column, value) {
      return this.money(value);
    },
    dateFormatter(row, column, value) {
      return formatDate(value);
    },
    progressFormatter(row, column, value) {
      return this.progressMap[value] || "-";
    },
    rowClassName({ row }) {
      return this.isClosed(row) ? "closed-row" : "";
    },
    changePage(value) {
      this.page = value;
      this.fetchList();
    },
    changeSize(value) {
      this.pageSize = value;
      this.page = 1;
      this.fetchList();
    }
  }
};
</script>

<style scoped>
.claims-page {
  padding: 20px;
}
.search-toolbar {
  width: 100%;
}
.search-form {
  width: 100%;
}
.toolbar-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.search-actions {
  margin-bottom: 18px;
}
.toolbar-actions {
  display: flex;
  align-items: center;
  white-space: nowrap;
  margin-bottom: 18px;
}
.pagination {
  margin-top: 16px;
  text-align: right;
}
.danger-text {
  color: #f56c6c;
  font-weight: 600;
}
/deep/ .closed-row {
  color: #b7bac1;
}
/deep/ .claim-table .cell {
  white-space: nowrap;
}
</style>
